export default "__VITE_ASSET__xP$2rh43__"